import React from 'react';
import {MasterLayout} from 'layout';
import {TongHopKetQua} from 'modules/thong-ke-bao-cao';

class TongHopKetQuaThanhTraLaiPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <TongHopKetQua type='THANH_TRA_LAI'/>
      </MasterLayout>
    );
  }
}

export default TongHopKetQuaThanhTraLaiPage;


// WEBPACK FOOTER //
// ./src/components/pages/thong-ke-bao-cao/TongHopKetQuaThanhTraLaiPage.jsx